
<div
  id="map"
  ref="map"
  class="map"
  tabindex="0"
  :style="`height:${height}px`"
/>
